module.exports = __webpack_public_path__ + "img/notes-dashboard-icon.9dfe3c8.png";